import { render } from "./VLogo.vue?vue&type=template&id=5f437cc3"
import script from "./VLogo.vue?vue&type=script&lang=js"
export * from "./VLogo.vue?vue&type=script&lang=js"

import "./VLogo.vue?vue&type=style&index=0&id=5f437cc3&lang=scss"
script.render = render

export default script